import styled from 'styled-components';

export const Wrapper = styled.div`
	position: absolute;
	right: 20px;
	z-index: 5;
	
	/* &:before {
		content: '';
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		width: 10px;
		height: 300px;
		border-radius: 50%;
		box-shadow: 20px 0 50px #707070;
	} */
	.inner-form {
		background-color: #fff;
		padding: 8px 0 18px;
		height: 375px;
		overflow: auto;
		width: 262px;
		position: relative;
		border-right: 1px solid #e5e5e5;
		box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
		.subTab{
			display: flex;
			padding:  8px 26px;
			gap: 17px;
			img{
				width: 22px;
			}
			.subtab-title{
				font-weight: 600;
				font-size: 13px;
			}
			&:hover,
			&.active{
				background-color: #00BAF2;
				color: #fff;
				cursor: pointer;
			}
		}
	}
	.service-heading{
		font-size: 14px;
		padding: 0 26px;
		margin: 10px 0 4px;
		color: #00BAF2
	}
	
`;
